import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id", "options", "isWrapList", "value", "mode", "helperText", "isOrientation", "mainTitle", "subTitle", "wrapperStyles", "isEditable", "testId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import Checkbox from './checkbox.basic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CheckboxGroup = function CheckboxGroup(_ref) {
  var checkBoxId = _ref.id,
      options = _ref.options,
      _ref$isWrapList = _ref.isWrapList,
      isWrapList = _ref$isWrapList === void 0 ? true : _ref$isWrapList,
      value = _ref.value,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'static' : _ref$mode,
      helperText = _ref.helperText,
      isOrientation = _ref.isOrientation,
      mainTitle = _ref.mainTitle,
      subTitle = _ref.subTitle,
      wrapperStyles = _ref.wrapperStyles,
      _ref$isEditable = _ref.isEditable,
      isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
      testId = _ref.testId,
      rest = _objectWithoutProperties(_ref, _excluded);

  return options !== null && options !== void 0 && options.length ? /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(Wrapper, {
      wrapperStyles: wrapperStyles,
      isOrientation: isOrientation,
      id: "checkbox",
      isWrapList: isWrapList,
      isEditable: isEditable,
      "data-cy": testId,
      children: options.map(function (_ref2) {
        var key = _ref2.key,
            label = _ref2.label,
            id = _ref2.id;
        return /*#__PURE__*/_jsx(Item, {
          id: "".concat(id, "-").concat(checkBoxId),
          children: /*#__PURE__*/_jsx(Checkbox, _objectSpread({
            title: label,
            isChecked: value ? value.indexOf(id) !== -1 : undefined,
            mode: mode,
            id: id === null || id === void 0 ? void 0 : id.toString(),
            testId: "".concat(key, "-checkbox")
          }, rest), key)
        }, key);
      })
    }), helperText]
  }) : null;
};
export default CheckboxGroup;

var Wrapper = /*#__PURE__*/_styled.ul.withConfig({
  displayName: "checkboxgroup__Wrapper",
  componentId: "sc-1rax9p5-0"
})(["", " ", " ", " ", " ", ""], {
  "display": "flex",
  "height": "100%",
  "gap": "0.5rem",
  "@media (min-width: 768px)": {
    "maxHeight": "15rem",
    "overflowY": "auto",
    "paddingLeft": "1rem",
    "paddingRight": "1rem",
    "paddingTop": "0.25rem"
  }
}, function (_ref3) {
  var isWrapList = _ref3.isWrapList;
  return isWrapList ? {
    "@media (min-width: 768px)": {
      "flexWrap": "wrap"
    }
  } : {};
}, function (_ref4) {
  var isOrientation = _ref4.isOrientation;
  return isOrientation === 'row' ? {
    "flexDirection": "row",
    "flexWrap": "wrap",
    "gap": "1rem"
  } : {
    "flexDirection": "column"
  };
}, function (_ref5) {
  var isEditable = _ref5.isEditable;
  return isEditable ? {
    "paddingLeft": "0px !important",
    "paddingRight": "0px !important",
    "@media (min-width: 768px)": {
      "maxHeight": "fit-content"
    }
  } : {};
}, function (_ref6) {
  var wrapperStyles = _ref6.wrapperStyles;
  return wrapperStyles;
});

var Item = /*#__PURE__*/_styled.li.withConfig({
  displayName: "checkboxgroup__Item",
  componentId: "sc-1rax9p5-1"
})(["", " ", ""], {
  "paddingBottom": "0.5rem",
  "paddingLeft": "0.25rem"
}, function (_ref7) {
  var isEditable = _ref7.isEditable;
  return isEditable ? {
    "paddingLeft": "0px !important"
  } : {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "checkboxgroup___StyledDiv",
  componentId: "sc-1rax9p5-2"
})({
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "1rem"
});